<p-panel
  [toggleable]="true"
  [collapsed]="false"
  header="{{ 'recent-customers.title' | translate }}"
  styleClass="recent-customers-panel"
>
  <ng-template #headericons let-collapsed>
    @if (collapsed) {
      <span class="pi pi-chevron-down"></span>
    } @else {
      <span class="pi pi-chevron-up"></span>
    }
  </ng-template>
  <div class="recent-customers-list">
    @if (customers.length === 0) {
      <p class="recent-customers-empty">
        {{ 'recent-customers.empty' | translate }}
      </p>
    } @else {
      @for (customer of customers; track customer.id) {
        <div class="recent-customers-row" (click)="open(customer)">
          <span class="recent-customers-name"
            >{{ customer.firstName }} {{ customer.lastName }}</span
          >
          <span class="recent-customers-personal-id">{{
            customer.personalId
          }}</span>
        </div>
      }
    }
  </div>
</p-panel>
